import { Button } from "@mui/material";
import styled from "styled-components";

export const SummaryBtnsWrapper = styled.div`
  display: flex;
  gap: 1.5rem;
`

export const ClaimSummaryButton = styled(Button)`
  background: #2354d4 !important;
  font-size: 14px !important;
  border-radius: 6px !important;
  padding: 12px 24px !important;
  /* margin-top: 24px !important; */
  text-transform: capitalize !important;
  font-family: Inter !important;
  width: fit-content !important;
`;


export const ClaimSearchFilterWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 15px;
`

export const ClaimDonwloadBtn = styled.div`
  width: 56px !important;
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: center;
  border-radius: 6px;
  color: #fff;
  background: #2354d4 !important;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
              0px 2px 2px 0px rgba(0, 0, 0, 0.14),
              0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  transition: box-shadow 0.3s ease, background-color 0.3s ease;

  &:hover {
    box-shadow: 0px 4px 3px -2px rgba(0, 0, 0, 0.2),
                0px 4px 5px 0px rgba(0, 0, 0, 0.14),
                0px 2px 8px 1px rgba(0, 0, 0, 0.12);
    background: #1f4fc0; /* Slightly darker background on hover */
  }
`;